"use client";
import Markdown from "@/utils/Markdown";
import Image from "next/image";
export default function ServicesSteps(cluster: any) {
  return (
    <>
      <section className="md:py-16 md:pt-[5rem] pt-[3rem] bg-gray">
        <h3 className="text-center font-avHeavy">
          <Markdown>{cluster?.title}</Markdown>
        </h3>
        <div className="mx-auto container">
          <div className="flex md:flex-row flex-col justify-center py-8">
            {cluster?.steps.map((step: any, index: any) => (
              <div key={index} className="flex items-center">
                <div className="text-[120px] font-bold md:ml-[50px] ml-[30px]">
                  {step?.number}
                </div>
                <div className="w-[300px] ml-8">
                  <Markdown cls="bdy-txt-5">{step?.text}</Markdown>
                </div>
                <div>
                  {index !== cluster.steps.length - 1 && (
                    <Image
                      src="/assets/icons/arrow-right-colored.jpg"
                      alt="{sendMoney?.title}"
                      width={10}
                      height={10}
                      className=""
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
